import React from "react";
import ServiceHero from "../ServiceHero";
import Timeline from "../Timeline";
import BentoGrid from "../BentoGrid";
import FadeOnScroll from "../FadeOnScroll";

const maintenanceProcess = [
  { title: "Site Assessment", content: <p>Reviewing your website's performance.</p> },
  { title: "Bug Fixes & Updates", content: <p>Keeping everything running smoothly.</p> },
  { title: "Security Enhancements", content: <p>Implementing security best practices.</p> },
  { title: "Performance Optimisation", content: <p>Ensuring fast load times.</p> },
  { title: "Regular Backups", content: <p>Keeping your data safe and secure.</p> },
  { title: "Ongoing Support", content: <p>Helping you whenever you need it.</p> },
];

const maintenanceFeatures = [
  { title: "Regular Updates", description: "Ensuring compatibility & security.", image: "/assets/updates2-maintenance.png", className: "col-span-1 lg:col-span-4 border-b lg:border-r" },
  { title: "Performance Monitoring", description: "Real-time tracking & optimisations.", image: "/assets/performance-maintenance.png", className: "col-span-1 lg:col-span-2 border-b" },
  { title: "Security Patches", description: "Proactive security enhancements.", image: "/assets/security2-maintenance.png", className: "col-span-1 lg:col-span-3 lg:border-r" },
  { title: "Technical Support", description: "Providing you with an effective handover and support for you controlling your website.", image: "/assets/support-maintenance.png", className: "col-span-1 lg:col-span-3 border-b" },
];

const Maintenance = () => {
  return (
    <div className="w-full bg-[#f5f3eb] dark:bg-[#1c1c1c] min-h-screen">
      
      {/* Hero Section */}
      <FadeOnScroll>
        <ServiceHero 
          title="Keep Your Website Running Smoothly"
          description="Reliable maintenance services to keep your website up-to-date and secure."
          imageSrc="/assets/maintenance-her2.png"
          lightCircleColor="#F8C63B"  
          darkCircleColor="#D1A92C"     
        />
      </FadeOnScroll>

      {/* Timeline Section */}
      <FadeOnScroll>
        <Timeline 
          title="Website Maintenance Process"
          description="Our maintenance service ensures your website remains updated, secure, and optimized."
          data={maintenanceProcess} 
        />
      </FadeOnScroll>

      {/* What We Offer Section */}
      <FadeOnScroll>
        <div className="relative z-20 py-10 lg:py-40 max-w-7xl mx-auto">
          <div className="px-8">
            <h4 className="text-3xl lg:text-5xl text-center font-medium text-black dark:text-white">
              What We Offer
            </h4>
          </div>

          {/* Bento Grid for Features */}
          <BentoGrid features={maintenanceFeatures} />
        </div>
      </FadeOnScroll>
      
    </div>
  );
};

export default Maintenance;

